export * from './src/table.module';
export { GalaxyPaginatorText, INDETERMINATE_MAX } from './src/datasource/paginator-text';
